<template>
  <!-- BEGIN: Content-->
  <div>
    <CommonTable
        ref="commonTable"
        :url="url"
        :tableHeaderValues="tableHeaderValues"
        :actions="actions"
        :deleteActions="deleteActions"
        :mutedData="mutedData"
        :storageKey="storageKey"
        :externalTotalRecord="externalTotalRecord"
        :filteredData="filteredData"
        :exportData="exportData"
        :hidePdfExportButton="true"
        :show-per-page="true"
        :tableAccordian="ReserveInfoTable"
        :accordianCondition="accordianCondition"
        :actionDropdown="true"
        :selectable="true"
        selectionKey="uuid"
        :selectionCondition="selectionCondition"
        @selectionChanged="onSelectionChanged"
    >
      <template v-slot:bulkActions="{ selectedCount }">
        <button
            type="button"
            class="btn-sm btn btn-gradient-danger"
            :disabled="!selectedCount"
            @click="showBulkCancelConfirmationModal = true"
        >
          <feather type="x-circle"></feather>
          Cancel Settlements
        </button>
      </template>
    </CommonTable>
    <ProcessSettlementModal    :row="selectedSettlementRow"
                               :index="selectedSettlementIndex"
                               :vuexKey="storageKey"
                               :show="showProcessModal"
                               :settlementId="settlementId"
                               @hide="showProcessModal = false"
                               @processSuccess="$emit('changeTab',3)"
    ></ProcessSettlementModal>
    <ConfirmationModal :show="showConfirmationModal" @confirm="confirm" message="Are you sure to cancel the settlement?"
                       title="Cancel Settlement"
                       @hide="showConfirmationModal = false"></ConfirmationModal>
    <ConfirmationModal :show="showBulkCancelConfirmationModal" @confirm="bulkCancelConfirm"
                       :message="bulkCancelMessage"
                       title="Cancel Settlements"
                       @hide="showBulkCancelConfirmationModal = false"></ConfirmationModal>
    <ConfirmationModal :show="showTransmitConfirmationModal" @confirm="transitConfirm" message="Are you sure to transmit the settlement amount to IBAN?"
                       title="Transmit Settlement"
                       @hide="showTransmitConfirmationModal = false"></ConfirmationModal>
    <SettlementDetailsModal    :data="settlementDetailsData"
                               :show="showSettlementDetailsModal"
                               @hide="showSettlementDetailsModal = false"
    ></SettlementDetailsModal>
    <PaymentMethodsModal    :data="paymentMethodsData"
                               :show="showPaymentMethodsModal"
                               @hide="showPaymentMethodsModal = false"
    ></PaymentMethodsModal>
    <KeyValueModal :show="showSettingModel" :formatKey="true" :formatValue="true" heading="Settings" :data="settings"
                   @hide="showSettingModel = false"

    />
  </div>
  <!-- END: Content-->
</template>

<script>


import SettlementDetailsModal from "@/pages/dashboard/settlements/SettlementDetailsModal.vue";
import KeyValueModal from "@/components/common/modals/KeyValueModal.vue";
import PaymentMethodsModal from "@/pages/dashboard/settlements/PaymentMethodsModal.vue";

export default {
  components: {KeyValueModal, SettlementDetailsModal, PaymentMethodsModal},
  props:['filter'],
  mounted() {
    localStorage.setItem("url", "v1/get-settlement");
    this.checkDataInStore('v1/get-settlement')
    if (
        typeof this.$route.params.update == "undefined" &&
        typeof this.$route.params.add == "undefined"
    ) {
      this.$store.dispatch("set", null);
    }
  },
  data() {
    return {
      showSettingModel:false,
      settings:[],
      showSettlementDetailsModal:false,
      showPaymentMethodsModal:false,
      showTransmitConfirmationModal:false,
      settlementDetailsData:[],
      paymentMethodsData:[],
      accordianCondition:{
        condition:(row)=>{
          if(row.rolling_reserve){
            return true
          }
          return false
        }
      },
      ReserveInfoTable: {
        header: [
          {
            title: 'UUID'
          },
          {
            title: 'Reserve (Amount)'
          },
          {
            title: 'Reserve (%)'
          },
          {
            title: 'Status'
          },
          {
            title: 'Duration'
          },
          {
            title: 'Updated At'
          },
          {
            title: 'Created At'
          },

        ],
        body: {
          getData: (row) => {
            let finalData = []
            let temp = []
            if(typeof(row.rolling_reserve) != 'undefined' && row.rolling_reserve) {
              let temp = []
              temp.push(row.rolling_reserve?.uuid?row.rolling_reserve?.uuid:'N/A')
              temp.push(parseFloat(row.rolling_reserve?.amount)/100)
              temp.push(row.rolling_reserve?.rolling_reserve)
              if(row.rolling_reserve?.status == 0){
                temp.push('Pending')
              }else if(row.rolling_reserve?.status == 1){
                temp.push('Initiated')
              }
              else if(row.rolling_reserve?.status == 2){
                temp.push('Cancelled')
              }else{
                temp.push('Completed')
              }

              const {days,hours,mins} = this.convertDuration(row.rolling_reserve?.time_interval)

              let duration = days+' days '+hours+' hours '+mins+' mins'

              temp.push(duration)
              temp.push(new Date(row.rolling_reserve?.updated_at).toISOString().slice(0, 16).replace('T', ' '))
              temp.push(new Date(row.rolling_reserve?.created_at).toISOString().slice(0, 16).replace('T', ' '))

              finalData.push(temp)
            }
            return finalData
          },
          conditionalRendering:true,
          condition:(row,index)=>{
            if(row.rolling_reserve){
              return true
            }

            return false
          }
        },
      },
      selectedRow: '',
      selectedIndex: '',
      selectedSettlementIds:[],
      showBulkCancelConfirmationModal:false,
      /* same rule as the row level Cancel action */
      selectionCondition:(row)=>{
        return row.status <= 1
      },
      showConfirmationModal:false,
      exportData:{
        cta: (exportType) => {
          let requestData = {
            exportAs: exportType,
            reportType: 'settlements',
            // type:1,
            // status:1
          }

          let filter = this.filter

          delete filter.selectedChannel
          delete filter.selectedStore
          delete filter.selectedTerminal
          delete filter.settlementStatus
          delete filter.tabToShow

          requestData = {
            ...requestData,
            ...filter,
            // type : 'direct',
            // settlementStatus : 'initiated',
            // type:1,
            // status:1

            /*new filter approach start*/
            type : 'direct',
            settlementStatus : 'initiated',
            /*new filter approach end*/

          }


          this.downloadReport(requestData)
        }
      },
      selectedSettlementIndex:'',
      selectedSettlementRow:'',
      settlementId:'',
      showProcessModal:false,
      merchantUuid:'',
      merchantStatus:'',
      merchantIndex:'',
      merchantRow:'',
      search: "",
      startDate: "",
      endDate: "",
      url: "v1/get-settlement",
      storageKey: "direct-initiated-settlement",
      isDefault: false,
      status: "",
      filteredData: {type:'direct',settlementStatus : 'initiated'},
      tableHeaderValues: [
        {
          title: 'Id',
          valueKey: 'uuid',
          html: true,
          alter: (value,row) => {
            var html=''
            if(value)
              html = `<span class="text-primary" title="Click To Copy" style="cursor: pointer">${value}</span>`

              let createdBy = row.created_by
              html = `
                <div class="row">
                    <div class="col-12 ">
                       ${html}
                        <div class="badge mt-1 ${createdBy ? 'badge-light-primary' : 'badge-light-danger'}">${createdBy ? (createdBy?.first_name + '/' + createdBy?.email) : 'Auto Generated' }</div>
                    </div>
                </div>
                `

            return  html


          },
          cta: (row) => {
            if(row.uuid){
              this.copyText(row.uuid);
            }

          }
        },
        {
          title: 'Reference Id',
          valueKey: 'reference',
          html: true,
          alter: function(value) {
            var html=''
            if(value)
              html = `<span class="text-info" title="Click To Copy" style="cursor: pointer">${value}</span>`


            return  html


          },
          cta: (row) => {
            if(row.gateway_reference_id){
              this.copyText(row.gateway_reference_id);
            }

          }
        },
        {
          title: 'Account Title',
          valueKey: 'user_account.account_title',
          html: true,
          alter: function (value, row) {
            var html = ''
            html = ` <a href="javascript:void()" class="badge badge-light-info badge-info">${value}</a>`

            if (row.channel && row.channel.id == 0) {
              html = `
                  <div class="row">
                      <div class="col-12">
                         ${html}
                          <div class="badge text-secondary mt-1">For All Channels</div>
                      </div>
                  </div>
                  `;
            }

            return html


          }
        },
        {
          title: 'Email',
          valueKey: 'user_account.user.email',
          html: true,
          alter: function (value) {
            var html = ''
            html = html = ` <a href="javascript:void()" class="badge badge-glow badge-dark">${value}</a>`

            return html


          }
        },
        {
          title: 'Date(From)',
          valueKey: 'from_date',
        },
        {
          title: 'Date(To)',
          valueKey: 'to_date',
        },
        {
          title: 'Payable Amount',
          valueKey: 'amount',
          html: true,
          alter: (value,row) => {
            var html=''
            if(value)
              html = `<div  class="font-lg-4 font-weight-bolder text-dark">${this.modifyAmount(parseFloat(value / 100).toFixed(this.amountDecimalPlaces))}</div><div class="badge badge-light-success ml-1">${row.user_account.currency.code}</div>`


            return  html


          }
        },
        {
          title: 'Reserves',
          valueKey: 'rolling_reserve',
          html: true,
          alter: (value,row) =>  {
            var html=''
            if(value){
              html = `<div  class="font-lg-4 text-warning row justify-content-center ">${this.modifyAmount(parseFloat(value.amount / 100).toFixed(this.amountDecimalPlaces))}</div><div class="badge badge-light-success">${row.user_account.currency.code}</div>`


              html = `
            <span class="text-center">${html}
               <div class="badge badge-light-primary mt-1">${value.rolling_reserve + '%'}</div></span>

            `
            }





            return  html


          }
        },
        {
          title: 'Vat',
          valueKey: 'vat',
          html: true,
          alter: (value,row) =>  {
            var html=''

            html = ` <div  class="  text-dark">${parseFloat(value / 100).toFixed(this.feesDecimalPlaces)}</div><div class="badge badge-light-success ml-1">${row.user_account.currency.code}</div>`


            return  html
          }
        },
        {
          title: 'Fees',
          valueKey: 'fee',
          html: true,
          alter: (value,row) => {
            var html=''

            html = ` <div  class="  text-dark">${parseFloat(value / 100).toFixed(this.feesDecimalPlaces)}</div><div class="badge badge-light-success ml-1">${row.user_account.currency.code}</div>`


            return  html

          }
        },
        {
          title: 'Settlement Amount',
          valueKey: 'amount',
          html: true,
          alter: (value,row) => {
            var html=''
            if(value)
              html = `<div  class="font-lg-4 font-weight-bolder text-success">${this.modifyAmount(parseFloat((parseFloat(value)-parseFloat(row.vat)-parseFloat(row.fee)) / 100).toFixed(this.amountDecimalPlaces))}</div><div class="badge badge-light-success ml-1">${row.user_account.currency.code}</div>`

              if(row.rolling_reserve){
                html = `<div  class="font-lg-4 font-weight-bolder text-success">${this.modifyAmount(parseFloat((parseFloat(value)-parseFloat(row.vat)-parseFloat(row.fee)-parseFloat(row.rolling_reserve.amount)) / 100).toFixed(this.amountDecimalPlaces))}</div><div class="badge badge-light-success ml-1">${row.user_account.currency.code}</div>`
              }

            return  html


          }
        },
        {
          title: "Settlement Type",
          valueKey: "channel",
          html: true,
          alter: function(value, row) {
            // Settlement is either for a store or for a channel
            // Prefix is highlighted, the name follows it in the same badge
            let label = '-';
            if (row.store && row.store.name) {
              label = `<strong class="text-danger">Store:</strong> ${row.store.name}`;
            } else if (value && value.name) {
              label = `<strong class="text-danger">Channel:</strong> ${value.name}`;
            }
            let html = `<p class="badge badge-light-primary">${label}</p>`;
            if (row.payment_methods && row.payment_methods.length > 0) {
              const paymentMethod = row.payment_methods.find(pm => pm.pivot && pm.pivot.status === 1);
              if (paymentMethod) {
                html = `
                  <div class="row">
                      <div class="col-12">
                         ${html}
                          <div class="badge badge-light-warning">${paymentMethod.name}</div>
                      </div>
                  </div>
                  `;
              }
            }
            return html;
          }
        },
        {
          title: 'Status',
          valueKey: 'status',
          html: true,
          alter: function(value,row) {
            var html=''
            if(value)
              if (value == 1)
                html = `<div class="badge badge-pill  badge-glow badge-info">INITIATED</div>`
              else if (value == 2)
                html = `<div class="badge badge-pill  badge-glow badge-danger">CANCELED</div>`
              else if (value == 3)
                html = `<div class="badge badge-pill  badge-glow badge-success">DONE</div>`
              else
                html = `<div class="badge badge-pill  badge-glow badge-warning">PENDING</div>`


            return  html


          }
        },
        {
          title: 'Transaction Time/Date',
          valueKey: 'created_at',
          alter: (value) => {
            return this.customFormatDateTime(value)
          }
        },
      ],
      actions: [
        {
          title: 'settlement transaction',
          class: 'btn-warning mt-1',
          cta: (row,index) => {
            let data = {
              index: index,
              row: row,
              key: "mainSettlementData"
            };
            this.$store.dispatch("set", data);
            let propFilters = this.filter
            this.$router.push({name: 'direct-settlements-detail',params: {settlementStatus :'initiated',id:row.id,propFilters: propFilters}})
          }
        },
        {
          title: 'skipped transactions',
          class: 'btn-warning mt-1',
          cta: (row,index) => {
            let data = {
              index: index,
              row: row,
              key: "mainSettlementData"
            };
            this.$store.dispatch("set", data);
            let propFilters = this.filter
            this.$router.push({name: 'direct-settlements-skipped-detail',params: {settlementStatus :'initiated',id:row.id,propFilters: propFilters}})
          }
        },
        {
          title: 'Details',
          class: 'btn-primary mt-1',
          cta: (row,index) => {
            this.settlementDetailsData = []
            if(row.settlment_details && row.settlment_details.length>0){
              this.settlementDetailsData = row.settlment_details
            }
            this.showSettlementDetailsModal = true
          }
        },
        {
          title: 'Payment Methods',
          class: 'btn-primary mt-1',
          cta: (row,index) => {
            this.paymentMethodsData = []
            if(row.payment_methods && row.payment_methods.length>0){
              this.paymentMethodsData = row.payment_methods
            }
            this.showPaymentMethodsModal = true
          }
        },
        {
          title: 'Cancel',
          conditionalRendering: true,
          condition: (row)=>{
            if(row.status  >1 ){
              return false
            }
            return true
          },
          class: 'btn-danger mt-1',
          cta: (row,index) => {
            this.selectedRow = row
            this.selectedIndex = index
            this.showConfirmationModal = true
            // this.cancelSettlement(row, index)
          }
        },
        // {
        //   title: 'Transmit',
        //   class: 'btn-danger mt-1',
        //   cta: (row,index) => {
        //     this.selectedRow = row
        //     this.selectedIndex = index
        //     this.showTransmitConfirmationModal = true
        //   }
        // },
        {
          title: 'Process',
          conditionalRendering: true,
          condition: (row)=>{
            if(row.status  >1 ){
              return false
            }
            return true
          },
          class: 'btn-success mt-1',
          cta: (row,index) => {
            this.settlementId = row.uuid
            this.selectedSettlementIndex = index
            this.selectedSettlementRow = row
            this.showProcessModal = true
          }
        },
        {
          title: 'Settings',
          // conditionalRendering: true,
          // condition: (row)=>{
          //   if(row.created_by){
          //     return false
          //   }
          //   return true
          // },
          class: 'btn-success mt-1',
          cta: (row,index) => {
            if(row?.details?.settings){
              this.settings = row?.details?.settings
            }
            this.showSettingModel = true
          }
        },
      ],
      deleteActions: [],
      mutedData: [],
      externalTotalRecord: ""
    };
  },
  methods: {
    onSelectionChanged(selection){
      this.selectedSettlementIds = selection.keys
    },
    bulkCancelConfirm(){
      let settlementIds = this.selectedSettlementIds
      if(!settlementIds.length){
        this.showBulkCancelConfirmationModal = false
        return
      }
      this.$store.dispatch('exportExcelLoader', true)
      this.makeRequest("post", "v1/cancel-settlement", {
        settlementIds: settlementIds,
      }).then(callResponse => {
        this.$store.dispatch('exportExcelLoader', false)
        this.showBulkCancelConfirmationModal = false
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          if (code == 200) {
            if(this.$refs.commonTable){
              this.$refs.commonTable.clearSelection()
            }
            this.$emit('changeTab',2)
          }
        }
      });
    },
    transitConfirm(){
      let row = this.selectedRow
      let index = this.selectedIndex
      this.$store.dispatch('exportExcelLoader', true)
      this.makeRequest("post", "v1/transmit-settlement", {
        settlementIds: [row.uuid],
      }).then(callResponse => {
        this.$store.dispatch('exportExcelLoader', false)
        this.loader = false
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            this.showTransmitConfirmationModal = false
            this.$emit('changeTab',4)
          }
        }


      });
    },
    confirm() {
      let row = this.selectedRow
      let index = this.selectedIndex
      this.$store.dispatch('exportExcelLoader', true)
      this.makeRequest("post", "v1/cancel-settlement", {
        settlementIds: [row.uuid],
      }).then(callResponse => {

        this.loader = false
        if (!callResponse.error) {
          this.$store.dispatch('exportExcelLoader', false)
          let code = callResponse.response.data.code;

          if (code == 200) {
            this.$emit('changeTab',2)
            // let data = {
            //   index: index,
            //   row: row,
            //   key: this.storageKey
            // };
            // data.row.status = callResponse.response.data.data.status
            // let storeData = this.$store.getters.getByKey(this.storageKey);
            // if (storeData != null) {
            //   if (typeof storeData.firstPageData != "undefined") {
            //     if (
            //         typeof storeData.firstPageData.data[data.index] != "undefined"
            //     ) {
            //       if (
            //           storeData.firstPageData.data[data.index].id == data.row.id
            //       ) {
            //         storeData.firstPageData.data[data.index] = data.row;
            //         delete storeData.otherPageData;
            //       }
            //     }
            //   }
            //   if (typeof storeData.otherPageData != "undefined") {
            //     if (
            //         typeof storeData.otherPageData.data[data.index] != "undefined"
            //     ) {
            //       if (
            //           storeData.otherPageData.data[data.index].id == data.row.id
            //       ) {
            //         storeData.otherPageData.data[data.index] = data.row;
            //       }
            //     }
            //   }
            //   storeData.key = this.storageKey;
            //   this.$store.dispatch("set", storeData);
            // }
            // this.$emit('hide')
          }
        }
        this.showConfirmationModal = false

      });
    }
  },
  computed:{
    bulkCancelMessage(){
      let count = this.selectedSettlementIds.length
      return 'Are you sure to cancel ' + count + ' selected settlement' + (count > 1 ? 's' : '') + '?'
    }
  },
  watch:{
    filter(val){
      let temp = val
      temp.type = 'direct'
      temp.settlementStatus = 'initiated'
      this.filteredData = temp
    }
  }
};
</script>
